import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import TermsAndFormsItemBlockData from 'Models/Content/TermsAndFormsItemBlockData';
import TermsAndFormsItemsBlockData from 'Models/Content/TermsAndFormsItemsBlockData';
import React from 'react';
import {Container, Row} from 'reactstrap';
import { buildUrlAndOpenWindow } from 'app/utilities/StringHelpers/StringHelpers';

const TermsAndFormsItemsBlock = ({data, context}: ComponentProps<TermsAndFormsItemsBlockData>) => {
  const items = data.items.expandedValue as TermsAndFormsItemBlockData[];
  return (
    <div className='TermsAndFormsItemsBlock'>
      <Container fluid='md'>
        <Row noGutters>
          <div className='TermsAndFormsItemsBlock__items'>
            {items.map((item, i) => (
              <div className='TermsAndFormsItemsBlock__items__item' key={i}>
                <div className='TermsAndFormsItemsBlock__items__item__title'>{item.title.value}</div>
                <div className='TermsAndFormsItemsBlock__items__item__button' onClick={() => buildUrlAndOpenWindow(item.link.value)}>
                  {item.linkTitle.value}
                </div>
              </div>
            ))}
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default TermsAndFormsItemsBlock;
